import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { MessageService } from 'primeng/api';
import { ICategoryOut } from 'src/app/shared/interfaces/categoryOut';
import { IDoctor } from 'src/app/shared/interfaces/doctor';
import { EGender } from 'src/app/shared/interfaces/gender-enum';
import { UserStatus } from 'src/app/shared/interfaces/userStatus-enum';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-account-info',
  templateUrl: './doctor-info.component.html',
  styleUrl: './doctor-info.component.css'
})
export class DoctorInfoComponent implements OnInit {

  drID: any;
  drInfo: IDoctor = {
    id: 7,
    name: "",
    family: '',
    meliCode: '',
    medicalEspertiseId: 0,
    medicalEspertiseName: '',
    status: 1,
    profilePic: '',
    img: null,
    gender: 1,
    codeNo: '',
    tel: '',
    mobile: '',
    birthDate: 0,
    sheba: '',
    bank: '',
    card: '',
    accountNo: '',
    workAddress: '',
    aboutMe: '',
    officeEquipment: '',
    imgFile: null,
    tags: [] = [],
    lags: [] = [],
    isActiveAttendanceVisit: false,
    experience: 1390,
    birthDatePlace: '',
    email: '',
    education_s: '',
    workPlace: ''
  };

  categoriesList: ICategoryOut[];
  genderEnum = EGender;
  keywords: string;  
  selectedData: any;
  lang: any;
  userState = UserStatus;

  
  constructor(
    public apiService: ApiService,
    private messageService: MessageService,
    private route: ActivatedRoute
  ){}


  ngOnInit(): void {
    this.drID = this.route.snapshot.params.id;

    this.getDoctorInfo();
    this.getCategoriesList();
  }

  getDoctorInfo(){
    this.apiService.apiCall('get', '/api/Doctor/Get/' + this.drID).subscribe((res: any) => {
      console.log(res);
      
      this.drInfo = res.body.model;
    })
  }

  getCategoriesList() {
    this.apiService.apiCall('post', '/api/Category/GetAll/2/0', {pagesize:200}).subscribe((res: any) => {
      console.log(res);
      this.categoriesList = res.body.model;
    })
  }

  @ViewChild('modal') modal!: ModalComponent;

  heartDis: boolean;
  lungDis: boolean;
  url: any;

  // -------------------Image----------------
  // file: any;
  localUrl: File = null;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  showCropper = false;
  imageChangedEvent: File = null;
  croppedImage: any;

  onItemChange(value) {
    console.log(' Value is : ', value);
  }

  updateDoctorInfo() {
    // const editDr = {
    //   codeNo: this.drInfo.codeNo,
    //   meliCode: this.drInfo.meliCode,
    //   medicalEspertiseId: this.drInfo.medicalEspertiseId,
    //   workAddress: this.drInfo.workAddress
    // }
    console.log(this.drInfo);
    
    this.apiService.apiCall('post','/api/User/EditDoctor', this.drInfo).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'تغییرات با موفقیت اعمال شد.' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

  ////////////////////////// Managing profile image

  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event1) => { // called once readAsDataURL is completed
        // this.url = event1.target.result;       

      }
      this.imageChangedEvent = event;
      this.modal.open();
    }

  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

  }
  imageLoaded(image: LoadedImage) {
    this.showCropper = true;
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
}
